export default "__VITE_ASSET__CG10KZIq__"